
import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { useSellerProcurements } from '@/hooks/use-seller-procurements';
import SellerProcurementSearch from './SellerProcurementSearch';
import SellerProcurementStatusFilter from './SellerProcurementStatusFilter';
import SellerProcurementTable from './SellerProcurementTable';
import SellerProcurementPagination from './SellerProcurementPagination';

const SellerProcurementList: React.FC = () => {
  const {
    procurements,
    isLoading,
    sortConfig,
    handleSort,
    filterOptions,
    setSearchTerm,
    setStatus,
    resetFilters,
    currentPage,
    totalPages,
    pageSize,
    setPageSize,
    goToPage,
    totalCount
  } = useSellerProcurements();

  if (isLoading) {
    return (
      <div className="space-y-4">
        <div className="flex justify-center items-center py-8">
          <Loader2 className="animate-spin w-8 h-8 text-primary mr-2" />
          <span className="text-lg">Loading your procurements...</span>
        </div>
        <div className="space-y-3">
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:flex-row gap-4 items-center">
        <SellerProcurementSearch 
          searchTerm={filterOptions.searchTerm} 
          setSearchTerm={setSearchTerm} 
        />
        <div className="flex gap-2">
          <SellerProcurementStatusFilter
            value={filterOptions.status}
            onChange={setStatus}
          />
          <Button variant="outline" onClick={resetFilters}>
            Reset Filters
          </Button>
        </div>
      </div>
      
      {procurements.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-muted-foreground">
            {filterOptions.status !== 'all' || filterOptions.searchTerm 
              ? "No procurements found matching your filters." 
              : "You haven't created any procurements yet."}
          </p>
        </div>
      ) : (
        <>
          <SellerProcurementTable 
            procurements={procurements}
            sortConfig={sortConfig}
            handleSort={handleSort}
          />
          <SellerProcurementPagination
            currentPage={currentPage}
            totalPages={totalPages}
            pageSize={pageSize}
            totalCount={totalCount}
            onPageChange={goToPage}
            onPageSizeChange={setPageSize}
          />
        </>
      )}
    </div>
  );
};

export default SellerProcurementList;
